import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {MaintenanceWorks} from "@/variants/index.js";

export const MaintenanceWork = ({data}) => (
	<AntdTable
		tableSize={"small"}
		scroll={500}
		data={data}
		columns={MaintenanceWorks.getColumns(data)}
		data-testid="maintenance-work-table"
	/>
);
